import React from 'react'

export default function Permissions() {
  return (
    <div>Permissions</div>
  )
}
